<script setup lang="ts">
import { onMounted } from 'vue';

import DashboardLayout from '~/layouts/DashboardLayout.vue';
import router from '~/router';

onMounted(() => {
  router.push({ name: '/financings' });
});
</script>

<template>
  <DashboardLayout name="index">
    <h1>Hello!</h1>
  </DashboardLayout>
</template>
